
<div class="pad-me">
  <div class="modal-header">
    <h2 mat-dialog-title>Upload Documents</h2>
    <button mat-dialog-close mat-icon-button (click)="checkUploadedDocuments()"><span class="material-symbols-outlined">close</span></button>
  </div>
  <mat-dialog-content>
    @if (singleDocumentControlNumber) {
    <app-required-docs-upload-special-enrollment
        [customConfigs]="customDocumentTableConfigs"
        [existingDocs]="existingDocs"
        [singleDocumentControlNumber]="singleDocumentControlNumber"
        [allowedFileExtensions]="individualAllowedExtensions"
        [uploadFile]="onUploadFile()">
      </app-required-docs-upload-special-enrollment>
    } @else {
      <div class="center-loader">
        <mat-spinner [diameter]="25"></mat-spinner>
      </div>
    }
  </mat-dialog-content>
</div>
